import {
    Department,
    Service,
    NewsArticle,
    Officer,
    Act,
    Stat,
    PublicInfoItem,
    EmergencyContact,
    MobileApplication,
    Scheme,
    Tender
} from '../types/domain';


export interface Portal {
    id: string;
    name: string;
    url: string;
    logo?: string;
}

export const GOVERNMENT_PORTALS: Portal[] = [];

export const STATIC_OFFICERS: Officer[] = [];

export interface NavItem {
    id: string;
    label: string;
    labelHi?: string;
    path: string;
    icon: string;
    description?: string;
    children?: NavItem[];
}

export interface NavSection {
    id: string;
    label: string;
    labelHi?: string;
    icon: string;
    path?: string; // Direct link path (no dropdown)
    items: NavItem[];
}

export const NAVIGATION_CONFIG: NavSection[] = [
    {
        id: 'municipal',
        label: 'Municipal Council',
        icon: 'Building2',
        items: [
            { id: 'about', label: 'About Us', path: '/about', icon: 'Info', description: 'History, vision, and mission' },
            { id: 'team', label: 'Our Team', path: '/team', icon: 'Users', description: 'Leadership and key officials' },
            { id: 'departments', label: 'Departments', path: '/departments', icon: 'Building2', description: 'All municipal departments' },
            { id: 'wards', label: 'Ward Information', path: '/wards', icon: 'Map', description: 'Ward-wise details' },
            { id: 'performance', label: 'Performance', path: '/performance', icon: 'TrendingUp', description: 'Achievements and metrics' },
            { id: 'directory', label: 'Staff List', path: '/employees', icon: 'Phone', description: 'Staff directory' }
        ]
    },
    {
        id: 'offerings',
        label: 'Offerings',
        icon: 'Briefcase',
        items: [
            { id: 'services', label: 'Citizen Services', path: '/services', icon: 'Users', description: 'All online services' },
            { id: 'schemes', label: 'Schemes & Programs', path: '/schemes', icon: 'Award', description: 'Government schemes' },
            { id: 'vacancies', label: 'Vacancies', path: '/vacancies', icon: 'Briefcase', description: 'Job opportunities' },
            { id: 'initiatives', label: 'Initiatives', path: '/initiatives', icon: 'Lightbulb', description: 'Special initiatives' }
        ]
    },
    {
        id: 'media',
        label: 'Media',
        icon: 'Eye',
        items: [
            { id: 'photos', label: 'Photo Gallery', path: '/gallery/photos', icon: 'Eye', description: 'Event photographs' },
            { id: 'videos', label: 'Video Gallery', path: '/gallery/videos', icon: 'Eye', description: 'Video archive' }
        ]
    },
    {
        id: 'news',
        label: 'News & Updates',
        icon: 'Newspaper',
        items: [
            { id: 'all-news', label: 'Latest News', path: '/news', icon: 'Newspaper', description: 'All news and announcements' },
            { id: 'tenders', label: 'Tenders', path: '/tenders', icon: 'FileText', description: 'Current tenders' }
        ]
    },
    {
        id: 'connect',
        label: 'Connect',
        icon: 'MessageSquare',
        items: [
            { id: 'contact', label: 'Contact Us', path: '/location', icon: 'MapPin', description: 'Office location and contacts' },
            { id: 'grievance', label: 'Grievance Redressal', path: '/grievance', icon: 'AlertCircle', description: 'Submit complaints' },
            { id: 'feedback', label: 'Feedback', path: '/feedback', icon: 'MessageSquare', description: 'Share your feedback' },
            { id: 'engagement', label: 'Citizen Engagement', path: '/engagement', icon: 'Users', description: 'Participate actively' }
        ]
    },
    {
        id: 'documents',
        label: 'Documents',
        icon: 'FileText',
        path: '/documents',
        items: []
    }
];

// Static data arrays have been migrated to site-data.xlsx


// Empty exports removed. Use useData hook.

// Re-export types
export type {
    Department,
    Service,
    NewsArticle,
    Officer,
    Act,
    Stat,
    PublicInfoItem,
    EmergencyContact,
    MobileApplication,
    Scheme,
    Tender
};
